// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"jxfoI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalCardViewContext", ()=>InternalCardViewContext);
parcelHelpers.export(exports, "CardContext", ()=>CardContext);
parcelHelpers.export(exports, "Card", ()=>Card);
parcelHelpers.export(exports, "CardPreview", ()=>CardPreview);
parcelHelpers.export(exports, "CollectionCardPreview", ()=>CollectionCardPreview);
parcelHelpers.export(exports, "AssetCard", ()=>AssetCard);
parcelHelpers.export(exports, "UserCard", ()=>UserCard);
parcelHelpers.export(exports, "ProductCard", ()=>ProductCard);
var _jsxRuntime = require("react/jsx-runtime");
var _actionMenu = require("./ActionMenu");
var _avatar = require("./Avatar");
var _button = require("./Button");
var _checkbox = require("./Checkbox");
var _reactAriaComponents = require("react-aria-components");
var _content = require("./Content");
var _react = require("react");
var _divider = require("./Divider");
var _utils = require("@react-aria/utils");
var _icon = require("./Icon");
var _image = require("./Image");
var _imageCoordinator = require("./ImageCoordinator");
var _runtime = require("../style/runtime");
var _pressScale = require("./pressScale");
var _skeleton = require("./Skeleton");
var _utils1 = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const borderRadius = {
    default: 'lg',
    size: {
        XS: 'default',
        S: 'default'
    }
};
let card = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let width = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_I|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "Z") width = true;
        rules += p[0];
    }
    rules += ' sd112';
    rules += ' _ta112';
    if (!position) rules += ' _Pc112';
    if (props.size === "S") rules += ' ob112';
    else if (props.size === "XS") rules += ' ob112';
    else rules += ' oc112';
    if (props.size === "S") rules += ' nb112';
    else if (props.size === "XS") rules += ' nb112';
    else rules += ' nc112';
    if (props.size === "S") rules += ' kb112';
    else if (props.size === "XS") rules += ' kb112';
    else rules += ' kc112';
    if (props.size === "S") rules += ' jb112';
    else if (props.size === "XS") rules += ' jb112';
    else rules += ' jc112';
    if (props.variant === "secondary") rules += ' -Ovbhqd-gqlRAZb112';
    else if (props.variant === "primary") rules += ' -Ovbhqd-g_g112';
    rules += ' -Ovbhqd-lgb112';
    if (props.variant === "quiet") rules += ' g9112';
    else if (props.variant === "tertiary") rules += ' g9112';
    else rules += ' gEzkoQe112';
    if (props.variant === "quiet") rules += ' _nd112';
    else if (props.variant === "tertiary") {
        if (props.isSelected) rules += ' _nd112';
        else if (props.isFocusVisible) rules += ' _nIvHxVd112';
        else if (props.isHovered) rules += ' _nIvHxVd112';
        else rules += ' _nEoUQN112';
        rules += ' _nlAvWjK112';
    } else {
        if (props.isSelected) rules += ' _nb112';
        else if (props.isFocusVisible) rules += ' _nb112';
        else if (props.isHovered) rules += ' _nb112';
        else rules += ' _na112';
        rules += ' _nlAvWjK112';
    }
    rules += ' _yb112';
    rules += ' Yd112';
    rules += ' Xb112';
    rules += ' _2b112';
    rules += ' uk112';
    rules += ' uch112';
    rules += ' udi112';
    rules += ' uea112';
    rules += ' ugb112';
    rules += ' uhd112';
    rules += ' uje112';
    rules += ' u2NhKxcl112';
    rules += ' uic112';
    if (props.variant === "quiet") rules += ' _Ne112';
    else rules += ' _Nb112';
    if (props.variant === "quiet") rules += ' Pe112';
    else rules += ' Pb112';
    rules += ' _qc112';
    rules += ' __ca112';
    if (props.isCardView) rules += ' _4c112';
    if (props.isLink) rules += ' ry112';
    if (props.isCardView) {
        if (!width) rules += ' Za112';
    } else if (props.size === "XL") {
        if (!width) rules += ' ZA112';
    } else if (props.size === "L") {
        if (!width) rules += ' Zy112';
    } else if (props.size === "M") {
        if (!width) rules += ' Zt112';
    } else if (props.size === "S") {
        if (!width) rules += ' Zr112';
    } else if (props.size === "XS") {
        if (!width) rules += ' ZI112';
    }
    rules += ' Fb112';
    if (props.density === "spacious") {
        if (props.size === "XL") rules += ' -dAV6Jb-Ti112';
        else if (props.size === "L") rules += ' -dAV6Jb-Th112';
        else if (props.size === "M") rules += ' -dAV6Jb-Tg112';
        else if (props.size === "S") rules += ' -dAV6Jb-Tf112';
        else if (props.size === "XS") rules += ' -dAV6Jb-Te112';
    } else if (props.density === "regular") {
        if (props.size === "XL") rules += ' -dAV6Jb-Th112';
        else if (props.size === "L") rules += ' -dAV6Jb-Tg112';
        else if (props.size === "M") rules += ' -dAV6Jb-Tf112';
        else if (props.size === "S") rules += ' -dAV6Jb-Te112';
        else if (props.size === "XS") rules += ' -dAV6Jb-Tt112';
    } else if (props.density === "compact") {
        if (props.size === "XL") rules += ' -dAV6Jb-Tg112';
        else if (props.size === "L") rules += ' -dAV6Jb-Tf112';
        else if (props.size === "M") rules += ' -dAV6Jb-Te112';
        else if (props.size === "S") rules += ' -dAV6Jb-Tt112';
        else if (props.size === "XS") rules += ' -dAV6Jb-T1DOfn112';
    }
    if (props.variant === "quiet") rules += ' -jXLvjd-Td112';
    else rules += ' -jXLvjd-T5gMYHd112';
    if (props.variant === "quiet") rules += ' -iXLvjd-Sd112';
    else rules += ' -iXLvjd-S5gMYHd112';
    rules += ' TxTaQHd112';
    rules += ' QxTaQHd112';
    rules += ' S0SaQHd112';
    rules += ' R0SaQHd112';
    rules += ' _oa112';
    if (props.variant === "quiet") rules += ' _Le112';
    else if (props.isFocusVisible) rules += ' _Lf112';
    else rules += ' _Le112';
    rules += ' Oh112';
    rules += ' _Mc112';
    rules += ' _Kd112';
    return rules;
};
let selectionIndicator = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa112';
    rules += ' Wr112';
    rules += ' _lr112';
    rules += ' _Ar112';
    rules += ' _zr112';
    rules += ' _9d112';
    if (props.size === "S") rules += ' ob112';
    else if (props.size === "XS") rules += ' ob112';
    else rules += ' oc112';
    if (props.size === "S") rules += ' nb112';
    else if (props.size === "XS") rules += ' nb112';
    else rules += ' nc112';
    if (props.size === "S") rules += ' kb112';
    else if (props.size === "XS") rules += ' kb112';
    else rules += ' kc112';
    if (props.size === "S") rules += ' jb112';
    else if (props.size === "XS") rules += ' jb112';
    else rules += ' jc112';
    rules += ' _Ob112';
    rules += ' _kc112';
    rules += ' hc112';
    rules += ' mc112';
    rules += ' lc112';
    rules += ' _jf112';
    rules += ' ik112';
    rules += ' Yd112';
    rules += ' Xb112';
    rules += ' _2b112';
    if (props.isSelected) rules += ' _Ib112';
    else rules += ' _Ia112';
    rules += ' OGcUfH112';
    rules += ' _Kc112';
    if (props.isStrokeInner) rules += ' _Lf112';
    else rules += ' _Le112';
    rules += ' _Mc112';
    return rules;
};
let preview = function anonymous(props) {
    let rules = " ";
    rules += ' _Pc112';
    rules += ' Yd112';
    rules += ' Xb112';
    rules += ' _2b112';
    rules += ' _Nb112';
    rules += ' Pb112';
    rules += ' I8cyuNb112';
    rules += ' H8cyuNb112';
    rules += ' J39J4qb112';
    rules += ' Gk39J4qb112';
    if (props.isQuiet) {
        if (props.size === "S") rules += ' ob112';
        else if (props.size === "XS") rules += ' ob112';
        else rules += ' oc112';
    }
    if (props.isQuiet) {
        if (props.size === "S") rules += ' nb112';
        else if (props.size === "XS") rules += ' nb112';
        else rules += ' nc112';
    }
    if (props.isQuiet) {
        if (props.size === "S") rules += ' kb112';
        else if (props.size === "XS") rules += ' kb112';
        else rules += ' kc112';
    }
    if (props.isQuiet) {
        if (props.size === "S") rules += ' jb112';
        else if (props.size === "XS") rules += ' jb112';
        else rules += ' jc112';
    }
    if (props.isQuiet) {
        if (props.isSelected) rules += ' _nb112';
        else if (props.isFocusVisible) rules += ' _nb112';
        else if (props.isHovered) rules += ' _nb112';
    }
    if (props.isQuiet) {
        if (props.isFocusVisible) rules += ' _Lf112';
    } else rules += ' _Le112';
    rules += ' Oh112';
    rules += ' _Mc112';
    rules += ' _Kd112';
    return rules;
};
const image = function anonymous(props) {
    let rules = " ";
    rules += ' Za112';
    if (props.layout === "grid") rules += ' fc112';
    rules += ' _Hb112';
    rules += ' _4c112';
    rules += ' _Ob112';
    return rules;
};
let title = function anonymous(props) {
    let rules = " ";
    rules += ' uk112';
    rules += ' uch112';
    rules += ' udi112';
    rules += ' uea112';
    rules += ' ugb112';
    rules += ' uhd112';
    rules += ' uje112';
    rules += ' u2NhKxcl112';
    rules += ' uic112';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e112';
        rules += ' vx112';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d112';
        rules += ' vx112';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-c112';
        rules += ' vx112';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b112';
        rules += ' vx112';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-b112';
        rules += ' vx112';
    }
    rules += ' wd112';
    rules += ' xd112';
    rules += ' _xa112';
    rules += ' wX0cczbc112';
    rules += ' xX0cczbc112';
    rules += ' _xX0cczba112';
    rules += ' wfd112';
    rules += ' xfd112';
    rules += ' _xfa112';
    rules += ' wfX0cczbc112';
    rules += ' xfX0cczbc112';
    rules += ' _xfX0cczba112';
    rules += ' _Fd112';
    rules += ' _FezxGHba112';
    rules += ' _FnuYUweb112';
    rules += ' po112';
    rules += ' __Ea112';
    rules += ' sa112';
    rules += ' __aa112';
    rules += ' __ba112';
    rules += ' zn9DOs112';
    rules += ' yn9DOs112';
    rules += ' Bn9DOs112';
    rules += ' An9DOs112';
    return rules;
};
let description = function anonymous(props) {
    let rules = " ";
    rules += ' uk112';
    rules += ' uch112';
    rules += ' udi112';
    rules += ' uea112';
    rules += ' ugb112';
    rules += ' uhd112';
    rules += ' uje112';
    rules += ' u2NhKxcl112';
    rules += ' uic112';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-d112';
        rules += ' vx112';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-c112';
        rules += ' vx112';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-b112';
        rules += ' vx112';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-a112';
        rules += ' vx112';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a112';
        rules += ' vx112';
    }
    rules += ' wb112';
    rules += ' xb112';
    rules += ' _xa112';
    rules += ' _Fb112';
    rules += ' _FnuYUwec112';
    rules += ' pt112';
    rules += ' __Ea112';
    rules += ' sa112';
    rules += ' __aa112';
    rules += ' __ba112';
    rules += ' z9u7zPc112';
    rules += ' y9u7zPc112';
    rules += ' B9u7zPc112';
    rules += ' A9u7zPc112';
    return rules;
};
let content = function anonymous(props) {
    let rules = " ";
    rules += ' se112';
    rules += ' DM8Mfn112';
    rules += ' DlsIuJI4ff4112';
    rules += ' CfLapxc112';
    rules += ' ClsIuJg9IhLd112';
    rules += ' qb112';
    rules += ' _ub112';
    rules += ' ea112';
    rules += ' _cf112';
    if (props.size === "XL") rules += ' Ue112';
    else if (props.size === "L") rules += ' UWJpoB112';
    else if (props.size === "M") rules += ' UWJpoB112';
    else if (props.size === "S") rules += ' Ub112';
    else if (props.size === "XS") rules += ' Ub112';
    rules += ' T5gMYHd112';
    rules += ' Tbd112';
    rules += ' Q69YG2b112';
    rules += ' Qkd112';
    return rules;
};
let actionMenu = " zgSHDrc112 ygSHDrc112 BgSHDrc112 AgSHDrc112 JTnYEIe112 GTnYEIe112";
let footer = " sd112 _tc112 ec112 _Ce112 Ue112 qe112 T69YG2b112";
const InternalCardViewContext = /*#__PURE__*/ (0, _react.createContext)({
    ElementType: 'div',
    layout: 'grid'
});
const CardContext = /*#__PURE__*/ (0, _react.createContext)(null);
const InternalCardContext = /*#__PURE__*/ (0, _react.createContext)({
    isQuiet: false,
    size: 'M',
    isSelected: false,
    isHovered: false,
    isFocusVisible: false,
    isPressed: false,
    isCheckboxSelection: true
});
const actionButtonSize = {
    XS: 'XS',
    S: 'XS',
    M: 'S',
    L: 'M',
    XL: 'L'
};
const Card = /*#__PURE__*/ (0, _react.forwardRef)(function Card(props, ref) {
    [props] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, CardContext);
    let { ElementType, layout } = (0, _react.useContext)(InternalCardViewContext);
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { density = 'regular', size = 'M', variant = 'primary', UNSAFE_className = '', UNSAFE_style, styles, id, ...otherProps } = props;
    let isQuiet = variant === 'quiet';
    let isSkeleton = (0, _skeleton.useIsSkeleton)();
    let children = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                (0, _image.ImageContext),
                {
                    alt: '',
                    styles: image({
                        layout
                    })
                }
            ],
            [
                (0, _content.TextContext),
                {
                    slots: {
                        [(0, _reactAriaComponents.DEFAULT_SLOT)]: {},
                        title: {
                            styles: title({
                                size
                            })
                        },
                        description: {
                            styles: description({
                                size
                            })
                        }
                    }
                }
            ],
            [
                (0, _content.ContentContext),
                {
                    styles: content({
                        size
                    })
                }
            ],
            [
                (0, _divider.DividerContext),
                {
                    size: 'S'
                }
            ],
            [
                (0, _content.FooterContext),
                {
                    styles: footer
                }
            ],
            [
                (0, _actionMenu.ActionMenuContext),
                {
                    isQuiet: true,
                    size: actionButtonSize[size],
                    isDisabled: isSkeleton,
                    // @ts-ignore
                    'data-slot': 'menu',
                    styles: actionMenu
                }
            ],
            [
                (0, _skeleton.SkeletonContext),
                isSkeleton
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageCoordinator.ImageCoordinator), {
            children: typeof props.children === 'function' ? props.children({
                size
            }) : props.children
        })
    });
    if (ElementType === 'div' || isSkeleton) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...(0, _utils.filterDOMProps)(otherProps),
        id: id != null ? String(id) : undefined,
        // @ts-ignore - React < 19 compat
        inert: (0, _utils.inertValue)(isSkeleton),
        ref: domRef,
        className: UNSAFE_className + card({
            size,
            density,
            variant,
            isCardView: ElementType !== 'div'
        }, styles),
        style: UNSAFE_style,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalCardContext.Provider, {
            value: {
                size,
                isQuiet,
                isCheckboxSelection: false,
                isHovered: false,
                isFocusVisible: false,
                isSelected: false,
                isPressed: false
            },
            children: children
        })
    });
    let press = (0, _pressScale.pressScale)(domRef, UNSAFE_style);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ElementType, {
        ...props,
        ref: domRef,
        className: (renderProps)=>UNSAFE_className + card({
                ...renderProps,
                isCardView: true,
                isLink: !!props.href,
                size,
                density,
                variant
            }, styles),
        style: (renderProps)=>// Only the preview in quiet cards scales down on press
            variant === 'quiet' ? UNSAFE_style : press(renderProps),
        children: ({ selectionMode, selectionBehavior, isHovered, isFocusVisible, isSelected, isPressed })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(InternalCardContext.Provider, {
                value: {
                    size,
                    isQuiet,
                    isCheckboxSelection: selectionMode !== 'none' && selectionBehavior === 'toggle',
                    isHovered,
                    isFocusVisible,
                    isSelected,
                    isPressed
                },
                children: [
                    !isQuiet && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectionIndicator, {}),
                    !isQuiet && selectionMode !== 'none' && selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardCheckbox, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " sc112",
                        children: children
                    })
                ]
            })
    });
});
function SelectionIndicator() {
    let { size, isSelected, isQuiet, isCheckboxSelection } = (0, _react.useContext)(InternalCardContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: selectionIndicator({
            size,
            isSelected,
            // Add an inner stroke only for quiet cards with no checkbox to
            // help distinguish the selected state from the preview.
            isStrokeInner: isQuiet && !isCheckboxSelection
        })
    });
}
function CardCheckbox() {
    let { size } = (0, _react.useContext)(InternalCardContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: " _Pa112 W5gMYHd112 _A5gMYHd112 _9d112 Tp112 Qp112 Sp112 Rp112 gGcUfH112 ob112 nb112 kb112 jb112 _na112",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
            slot: "selection",
            excludeFromTabOrder: true,
            size: size === 'XS' ? 'S' : size
        })
    });
}
const CardPreview = /*#__PURE__*/ (0, _react.forwardRef)(function CardPreview(props, ref) {
    let { size, isQuiet, isHovered, isFocusVisible, isSelected, isPressed, isCheckboxSelection } = (0, _react.useContext)(InternalCardContext);
    let { UNSAFE_className = '', UNSAFE_style } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ...(0, _utils.filterDOMProps)(props),
        slot: "preview",
        ref: domRef,
        className: UNSAFE_className + preview({
            size,
            isQuiet,
            isHovered,
            isFocusVisible,
            isSelected
        }),
        style: isQuiet ? (0, _pressScale.pressScale)(domRef)({
            isPressed
        }) : UNSAFE_style,
        children: [
            isQuiet && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectionIndicator, {}),
            isQuiet && isCheckboxSelection && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardCheckbox, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " oi112 ni112 ki112 ji112 _Nb112 Pb112",
                children: props.children
            })
        ]
    });
});
const collection = function anonymous(props) {
    let rules = " ";
    rules += ' se112';
    rules += ' DvhgoHd112';
    if (props.size === "S") rules += ' Ua112';
    else if (props.size === "XS") rules += ' Ua112';
    else rules += ' Ub112';
    if (props.size === "S") rules += ' qa112';
    else if (props.size === "XS") rules += ' qa112';
    else rules += ' qb112';
    return rules;
};
const collectionImage = " Za112 fa112 f5DbKFc112 y5DbKFwoofG112 _Hb112 _Ob112 _4c112";
const CollectionCardPreview = /*#__PURE__*/ (0, _react.forwardRef)(function CollectionCardPreview(props, ref) {
    let { size } = (0, _react.useContext)(InternalCardContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardPreview, {
        ...props,
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: collection({
                size
            }),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _image.ImageContext).Provider, {
                value: {
                    styles: collectionImage
                },
                children: props.children
            })
        })
    });
});
const AssetCard = /*#__PURE__*/ (0, _react.forwardRef)(function AssetCard(props1, ref) {
    let { layout } = (0, _react.useContext)(InternalCardViewContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Card, {
        ...props1,
        ref: ref,
        density: "regular",
        children: (0, _reactAriaComponents.composeRenderProps)(props1.children, (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                values: [
                    [
                        (0, _image.ImageContext),
                        {
                            alt: '',
                            styles: function anonymous(props) {
                                let rules = " ";
                                rules += ' Za112';
                                if (props.layout === "grid") rules += ' fa112';
                                rules += ' _Ha112';
                                rules += ' _Ob112';
                                rules += ' _4c112';
                                return rules;
                            }({
                                layout
                            })
                        }
                    ],
                    [
                        (0, _icon.IllustrationContext),
                        {
                            render (icon) {
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: " sd112 eb112 _Ca112 gH112 fa112",
                                        children: icon
                                    })
                                });
                            },
                            styles: " Fd112 Le112 Ke112 Zc112"
                        }
                    ]
                ],
                children: children
            }))
    });
});
const avatarSize = {
    XS: 24,
    S: 48,
    M: 64,
    L: 64,
    XL: 80
};
const UserCard = /*#__PURE__*/ (0, _react.forwardRef)(function UserCard(props, ref) {
    let { size = 'M' } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Card, {
        ...props,
        ref: ref,
        density: "spacious",
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                values: [
                    [
                        (0, _image.ImageContext),
                        {
                            alt: '',
                            styles: " Za112 fb112 _Hb112 _Ob112 _4c112"
                        }
                    ],
                    [
                        (0, _avatar.AvatarContext),
                        {
                            size: avatarSize[size],
                            UNSAFE_style: {
                                '--size': avatarSize[size] / 16 + 'rem'
                            },
                            styles: " _Pc112 Jy112 Jkymupd0fnV8d112",
                            isOverBackground: true
                        }
                    ]
                ],
                children: children
            }))
    });
});
const buttonSize = {
    XS: 'S',
    S: 'S',
    M: 'M',
    L: 'L',
    XL: 'XL'
};
const ProductCard = /*#__PURE__*/ (0, _react.forwardRef)(function ProductCard(props1, ref) {
    let { size = 'M' } = props1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Card, {
        ...props1,
        ref: ref,
        density: "spacious",
        children: (0, _reactAriaComponents.composeRenderProps)(props1.children, (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                values: [
                    [
                        (0, _image.ImageContext),
                        {
                            slots: {
                                preview: {
                                    alt: '',
                                    styles: " Za112 fd112 _Hb112 _Ob112 _4c112"
                                },
                                thumbnail: {
                                    alt: '',
                                    styles: function anonymous(props) {
                                        let rules = " ";
                                        rules += ' _Pc112';
                                        rules += ' _Ob112';
                                        rules += ' _4c112';
                                        if (props.size === "XL") rules += ' ZD112';
                                        else if (props.size === "L") rules += ' Zx112';
                                        else if (props.size === "M") rules += ' Zw112';
                                        else if (props.size === "S") rules += ' Zv112';
                                        else if (props.size === "XS") rules += ' Zo112';
                                        rules += ' FRuFGYc112';
                                        if (props.size === "S") rules += ' oa112';
                                        else if (props.size === "XS") rules += ' oa112';
                                        else rules += ' ob112';
                                        if (props.size === "S") rules += ' na112';
                                        else if (props.size === "XS") rules += ' na112';
                                        else rules += ' nb112';
                                        if (props.size === "S") rules += ' ka112';
                                        else if (props.size === "XS") rules += ' ka112';
                                        else rules += ' kb112';
                                        if (props.size === "S") rules += ' ja112';
                                        else if (props.size === "XS") rules += ' ja112';
                                        else rules += ' jb112';
                                        rules += ' _Hb112';
                                        rules += ' Jy112';
                                        rules += ' JkymupdLu7Bcc112';
                                        rules += ' _Lf112';
                                        if (props.size === "XS") rules += ' _Mb112';
                                        else rules += ' _Mc112';
                                        rules += ' OEzkoQe112';
                                        if (props.size === "XL") rules += ' -F_-Fy112';
                                        else if (props.size === "L") rules += ' -F_-Fw112';
                                        else if (props.size === "M") rules += ' -F_-Fv112';
                                        else if (props.size === "S") rules += ' -F_-Fu112';
                                        else if (props.size === "XS") rules += ' -F_-Fp112';
                                        return rules;
                                    }({
                                        size
                                    })
                                }
                            }
                        }
                    ],
                    [
                        (0, _content.FooterContext),
                        {
                            styles: (0, _runtime.mergeStyles)(footer, " _Cb112")
                        }
                    ],
                    [
                        (0, _button.ButtonContext),
                        {
                            size: buttonSize[size]
                        }
                    ],
                    [
                        (0, _button.LinkButtonContext),
                        {
                            size: buttonSize[size]
                        }
                    ]
                ],
                children: children
            }))
    });
});

},{"0":"1aScm","1":"djnhn","2":"9JVds","3":"k13eK","4":"29keh","5":"8UvLf","6":"kf2At","7":"l7rkT","8":"km8Hh","9":"659Zi","10":"lPr3p","11":"5WSnw","12":"ijKky","13":"PONm7","14":"jyVFO","15":"alaq0","16":"8VyXK","17":"8qJIV","18":"cGMB8","19":"kPtpC","20":"cKCLH","21":"eqAcu","react/jsx-runtime":"2Is6Z","./ActionMenu":"3fSPo","./Avatar":"f3T9F","./Button":"gZHck","./Checkbox":"jdSVu","react-aria-components":"bA6Cz","./Content":"10r6w","react":"a1TxN","./Divider":"kGk2u","@react-aria/utils":[["filterDOMProps","3upVm"],["inertValue","aL0AK"]],"./Icon":"jQAJE","./Image":"4LTiE","./ImageCoordinator":"3PQZz","../style/runtime":"8g9no","./pressScale":"8Ufux","./Skeleton":"1mUnF","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1aScm":[function() {},{}],"djnhn":[function() {},{}],"9JVds":[function() {},{}],"k13eK":[function() {},{}],"29keh":[function() {},{}],"8UvLf":[function() {},{}],"kf2At":[function() {},{}],"l7rkT":[function() {},{}],"km8Hh":[function() {},{}],"659Zi":[function() {},{}],"lPr3p":[function() {},{}],"5WSnw":[function() {},{}],"ijKky":[function() {},{}],"PONm7":[function() {},{}],"jyVFO":[function() {},{}],"alaq0":[function() {},{}],"8VyXK":[function() {},{}],"8qJIV":[function() {},{}],"cGMB8":[function() {},{}],"kPtpC":[function() {},{}],"cKCLH":[function() {},{}],"eqAcu":[function() {},{}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=ButtonGroup.d2fccf35.js.map
